<template>
  <div id="app" class="text-gray-700 relative">
    <Navbar />
    <Hero-Section />
    <Location title="कहाँ काम चाहियो ?" work="कहाँ ?" />
    <Location title="कस्तो काम चाहियो ? " work="काम ?" />
    <Blog />
    <Contact />
    <Footer />
  </div>
</template>

<script>

import Navbar from './components/Navbar.vue'
import HeroSection from './components/HeroSection.vue'
import Location from './components/Location.vue'
import Blog from './components/Blog.vue'
import Contact from './components/Contact.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    HeroSection,
    Location,
    Blog,
    Contact,
    Footer
  }
}
</script>

<style src='./assets/css/app.css' />

